import { Form } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { Link } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { FloatingButton } from './floating-button';
import { iconStyling, toolbarStyling } from './styles';

type Props = {
  documents: Form[];
  link?: Link;
  onClick: () => void;
  removeLink: () => void;
};

export const SelectedLinkToolbar = ({ documents, link, onClick, removeLink }: Props) => {
  const { t } = useTranslation('content-composer');

  const getSelectedLabel = () => {
    switch (link?.linkType) {
      case 'form':
        return documents.find((document) => document.id === link.url)?.name;
      case 'schedule':
        return t('Schedule');
      case 'confirmation':
        return t('Confirmation');
      case 'phone':
        return t('Practice Phone');
      case 'address':
        return t('Practice Address');
      case 'custom':
      default:
        return link?.url;
    }
  };

  return (
    <FloatingButton css={toolbarStyling}>
      <Icon name={link?.linkType === 'form' ? 'forms' : 'link'} css={iconStyling} />
      <Text
        as='span'
        color='primary'
        css={{
          textDecoration: 'underline',
          textUnderlineOffset: theme.spacing(0.5),
        }}
        onClick={onClick}
      >
        {getSelectedLabel()}
      </Text>
      <Icon name='x-small' onClick={removeLink} />
    </FloatingButton>
  );
};
